import React from 'react'
import "./styles.scss"
function LoadingIndicator() {
    return (
        <div className="loading-data-indicator">En cours de chargement ...</div>
    )
}

export default LoadingIndicator
